import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { REJECT_REASON } from 'domains/merchant-inbound-item-reject/constants'

const proptypes = {
  reject_reason: PropTypes.string
}

/**
 * To give nice look on Merchant Inbound Item Reject Reason.
 * It maps `reject_reason` to certain style and pass to `StatusBadge`.
 * @param {string} reject_reason - reject reason.
 */
const MerchantInboundItemRejectReasonBadge = ({ reject_reason }) => {

  const colorMap = REJECT_REASON[reject_reason] || 'default'

  return (
    <StatusBadge color={ colorMap } label={ reject_reason } />
  )
}

MerchantInboundItemRejectReasonBadge.propTypes = proptypes

export default MerchantInboundItemRejectReasonBadge
